import React from "react";
import { Modal, Button } from "@mantine/core";
import useStyles from "./style";

const InActivityLogoutModal = ({
  opened,
  close,
  setShowAlert,
  countdown,
  setCountdown,
  navigate,
}) => {
  const { classes } = useStyles();

  const keepLoginState = () => {
    setShowAlert(false);
    setCountdown(60);
  };

  return (
    <>
      <Modal.Root
        centered
        zIndex={1000}
        opened={opened}
        onClose={close}
        size="auto"
      >
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header className={classes.headerStyling}>
            <p className={classes.headerTitle}>Session Timeout</p>
          </Modal.Header>
          <Modal.Body>
            <div className={classes.modalContentParent}>
              <small>{` Your session will timeout in ${countdown} seconds due to inactivity.`}</small>
              <small className={classes.modalBottomText}>
                Click the "Stay Logged In" button to continue or click the
                "Logout" button to end session.
              </small>
            </div>
            <div className={classes.buttonsParent}>
              <Button
                className={classes.buttonsColor}
                variant="outline"
                color="yellow"
                onClick={() => {
                  navigate("/");
                  close();
                }}
              >
                Logout
              </Button>
              <Button
                className={classes.buttonsColor}
                ml={15}
                variant="filled"
                color="yellow"
                onClick={() => keepLoginState()}
              >
                Stay Logged In
              </Button>
            </div>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
};
export default InActivityLogoutModal;